var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',_vm._b({staticClass:"switch",attrs:{"type":"button","role":"switch","aria-checked":_vm.toggled.toString()},on:{"click":_vm.toggle}},'button',_vm.$attrs,false),[_c('span',{class:`slider round ${_vm.toggled === true ? 'slider__toggled' : ''}`})])])
}
var staticRenderFns = []

export { render, staticRenderFns }